export default async function getCommonDataBank({ context, nextMiddleware }){
    try {
        await context.store.dispatch('getEnv');
    }
    catch(e){
        return context.next(false);
    }
    return nextMiddleware();
}
